/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */
import * as References from './ReviewsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#generateTitle
 */
export const GENERATE_TITLE_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_generateTitle';
export const GENERATE_TITLE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GENERATE_TITLE_QUERY_FIELD_NAME,
  args: ['type', 'entityName', 'answers', 'ratings'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.generateTitleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getSummary
 */
export const GET_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getSummary';
export const GET_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUMMARY_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getStatsBatch
 */
export const GET_STATS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getStatsBatch';
export const GET_STATS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'type'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getStatsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});